import { GetDocumentRequestModel } from "../model/GetDocumentRequestModel";
import { deleteDocumentAPI, getDocument, moveDocumentAPI, deleteDocumentCustomer } from "../services/DocuMateAPI";
import { GetDocumentListQuery } from "../model/GetDocumentListQuery";
import { getUnAssignedDocument, getListOfFolderByGroupId } from "../services/DocuMateAPI";
import { getListOfGroup } from "../services/DocuMateAPI";
import { GetFolderListByGroupIdQuery } from "../model/GetFolderListByGroupIdQuery";
import { GroupListDto } from "../model/GroupListDto";
import { DocQueueGroupListResponseDto } from "../model/DocQueueGroupListResponseDto";
import { toast } from "react-toastify";
import Logger from "../../shared/services/Logger";
import * as constant from '../../shared/util/constant';

class DocuMateScanService {
    getUnAssignedDocument = async (getUnAssignedDocumentRequestModel: GetDocumentListQuery) => {
        var unassignedDocResponse = await getUnAssignedDocument(getUnAssignedDocumentRequestModel);
        let res =[];
        if(unassignedDocResponse.length > 0){
            res = unassignedDocResponse.map((item) => ({
                id: item.queueDocId,
                fileName: item.name,
                docFileId: item.fileId,
                folderId: getUnAssignedDocumentRequestModel.DocQueueId
            }));
        }

        return res;
    }

    getReScanDocument = async (getRescanDocumentRequestModel: GetDocumentListQuery) => {
        let res=[];
        var doc =await getUnAssignedDocument(getRescanDocumentRequestModel);
        if(doc.length> 0){
            res = doc.map((item) => ({
                id: item.queueDocId,
                fileName: item.name,
                docFileId: item.fileId,
            }));
        }

        return res;
    }

    getListOfDestinationFoldersData = async (): Promise<GroupListDto[]> => {
        var GroupList = await getListOfGroup(false);
        const groupList = GroupList.map((item: DocQueueGroupListResponseDto) => (
            {
                GroupId: item.id,
                GroupName: item.groupName,
                GroupCode: item.groupCode
            }));

        return groupList;
    }

    getFolderListByGroupId = async (getFolderListByGroupIdQuery: GetFolderListByGroupIdQuery) => {
        var doc = await getListOfFolderByGroupId(getFolderListByGroupIdQuery);
        return doc.map((item) => ({

            id: item.id,
            name: item.folderName,
            groupId: getFolderListByGroupIdQuery.GroupId,
            files: []
        }));
    }


    moveDocument = async (destinationFolders: any) => {

        let statusDoc = new Object();
        var unassignedDoc, rescanDoc;
        let isChange = false;
        //iterating over all documents which needs to be moved
        for (let i = 0; i < destinationFolders.length; i++) {
            let folder = destinationFolders[i];
            let todocqueueid = folder.id;
            let todocumentid = [];
            if (folder.files.length > 0) {
                isChange = true;
                //push all document id under a folder in one array
                folder.files.forEach(file => {
                    todocumentid.push(file.id);
                });

                let res = await moveDocumentAPI(constant.Documate.UnAssignedFolderID, todocqueueid, todocumentid);
                //storing error (if any) in key(document id) and value (error message) pair
                if(res.statusOfDocument != null && Object.entries(res.statusOfDocument).length > 0) {
                    Object.entries(res.statusOfDocument)
                        .map(([key]) => {
                            statusDoc[key] = res.statusOfDocument[key];
                        })
                }

                if (res.unAssignedDocumentList != null && res.unAssignedDocumentList.length > 0) {
                    unassignedDoc = res.unAssignedDocumentList.map((item) => ({
                        id: item.fileId,
                        fileName: item.name
                    }));
                }
                else
                {
                    unassignedDoc = [];
                }

                if(res.rescanDocumentList != null && res.rescanDocumentList.length > 0) {
                    rescanDoc = res.rescanDocumentList.map((item) => ({
                        id: item.fileId,
                        fileName: item.name
                    }));
                }
                else
                {
                    rescanDoc = [];
                }
            }
        }

        if (isChange)
            return { unassignedDoc, rescanDoc, statusDoc };
        else
            return null;
    }

    deleteDocument = async (listOfDocument: string[]) => {
        let res;
        var doc = await deleteDocumentAPI(listOfDocument);
        if (doc.remainingDocumentList != null && doc.remainingDocumentList.length > 0) {
            res = doc.remainingDocumentList.map((item) => ({
                id: item.fileId,
                fileName: item.name
            }));
        }

        return res;
    }

    getDocument = async (docId:string) => {
        var doc = await getDocument(docId);
        return doc;
    }    

    deleteDocumentcustomer = async (docId: string) => {
        let res;
        var doc = await deleteDocumentCustomer(docId);
        res = doc.isDeleted;
        return res;
    }
}

export default DocuMateScanService;